<div class="app-container">
  <app-super-admin-side-nav></app-super-admin-side-nav>
  <div class="main-content">
    <app-super-admin-header></app-super-admin-header>
    <router-outlet></router-outlet>
  </div>
</div>
